import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { yandexMetrikaHit } from "../analytics/yandexMetrika";
import { ensureYandexMetrikaLoaded } from "../analytics/loadYandexMetrika";
import { isAnalyticsAllowed } from "../utils/cookieConsent";
import { captureAdAttributionFromUrl } from "../utils/adAttribution";
import { capturePartnerRef } from "../utils/partnerRef";
import partnerAPI from "../services/partnerApi";

/**
 * Hit Метрики при SPA-навигации + захват yclid/UTM из URL.
 * Метрика грузится только после согласия на аналитические cookies.
 */
export default function YandexMetrikaTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAdAttributionFromUrl(location.search);
    const refParams = new URLSearchParams(location.search);
    const rawRef = refParams.get("ref") || refParams.get("partner") || "";
    const partnerCode = rawRef ? capturePartnerRef(rawRef) : "";
    if (partnerCode) {
      try {
        if (sessionStorage.getItem("bs_partner_tracked") !== partnerCode) {
          sessionStorage.setItem("bs_partner_tracked", partnerCode);
          partnerAPI.track(partnerCode).catch(() => {});
        }
      } catch {
        partnerAPI.track(partnerCode).catch(() => {});
      }
    }
    if (!isAnalyticsAllowed()) return;
    ensureYandexMetrikaLoaded().then((ok) => {
      if (ok) yandexMetrikaHit();
    });
  }, [location.pathname, location.search]);

  return null;
}
